import { render, staticRenderFns } from "./BlockRules.vue?vue&type=template&id=7e4f9636"
import script from "./BlockRules.vue?vue&type=script&lang=js"
export * from "./BlockRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports